import { Box, FormLabel, Typography, type TypographyProps } from '@mui/material';

interface FormStepTitleProps {
	title: string;
	titleId?: string;
	textAlign?: 'start' | 'center';
	pt?: number;
	variant?: TypographyProps['variant'];
	mb?: number;
}

const FormStepTitle = ({
	title,
	titleId,
	textAlign = 'start',
	pt,
	variant = 'header2',
	mb = 5,
}: FormStepTitleProps) => {
	return (
		<Box mb={mb} textAlign={textAlign} pt={pt}>
			<FormLabel id={titleId}>
				<Typography color="primary" variant={variant} data-test-id={`${title}-header`}>
					{title}
				</Typography>
			</FormLabel>
		</Box>
	);
};

export default FormStepTitle;
